// https://stackoverflow.com/questions/57807248/vuecli3-app-nginx-docker-use-environment-specific-variables
// https://ledermann.dev/blog/2018/04/27/dockerize-and-configure-javascript-single-page-application/
/* eslint-disable no-bitwise */
/* eslint-disable no-console */

export default class Configuration {
  static get CONFIG() {
    return {
      CACCOUNT_ADDRESS: '$VUE_APP_CACCOUNT_ADDRESS',
      CPRODUCT_ADDRESS: '$VUE_APP_CPRODUCT_ADDRESS',
      CPAYMENT_ADDRESS: '$VUE_APP_CPAYMENT_ADDRESS',
      CSTORAGE_ADDRESS: '$VUE_APP_CSTORAGE_ADDRESS',
      IS_STAGE: '$VUE_APP_IS_STAGE',
      RSA_PUB_KEY: '$VUE_APP_RSA_PUB_KEY',
    };
  }

  static value(key) {
    if (!(key in this.CONFIG)) {
      console.log(`Configuration: There is no key named "${key}"`);
      return null;
    }

    const value = this.CONFIG[key];

    if (!value) {
      console.log(`Configuration: Value for "${key}" is not defined`);
      return null;
    }

    if (!value.startsWith('$VUE_APP_')) {
      // value was already replaced, it seems we are in production (containerized).
      return value;
    }

    // value was not replaced, it seems we are in development.
    // Remove $ and get current value from process.env
    const envName = value.substr(1);
    const envValue = process.env[envName];
    if (!envValue) {
      console.error(`Configuration: Environment variable "${envName}" is not defined`);
      return null;
    }

    return envValue;
  }

  static valueBool(key) {
    const value = Configuration.value(key);
    if (value === null) {
      return false;
    }

    if (value.toLowerCase() === 'true') {
      return true;
    }

    return false;
  }
}



// WEBPACK FOOTER //
// ./src/js/Configuration.js